import React from "react";

import AdminPageGuard from "../components/AdminPageGuard";
import Header from "./components/header/Header";
import { StatusTable } from "./components/statusTable/StatusTable";
import "./report.scss";

const index = () => {
  return (
    <AdminPageGuard>
      <Header />
      <StatusTable />
    </AdminPageGuard>
  );
};

export default index;
